
"use strict";

angular.module('app.purchase.results.resultsController', [
])
  .controller('app.purchase.results.resultsController', [
    '$scope',
    '$state',
    '$stateParams',
    function ($scope, $state, $stateParams) {
        $scope.result = $stateParams.result;
        $scope.message = $stateParams.message;
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/purchase/results/resultsController.js